import { UserIcon } from '#assets/ReactSvg.ts';
import type { Host } from '#dn-types/host.ts';
import { osDisplayFromMetadata } from '#util/hostOs.ts';
import { ClientVersion } from './ClientVersion.tsx';
import { InlineIconLink } from './InlineIconLink.tsx';
import { LastSeenAt } from './LastSeenAt.tsx';
import styles from './HostSummaryRow.module.css';

type Props = {
  host: Host;
  dataUpdatedAt: Date;
  /** Owner's email, once {@link useDeviceOwnerEmails} has resolved it. */
  ownerEmail?: string;
};

export function HostSummaryRow({ host, dataUpdatedAt, ownerEmail }: Props) {
  const os = osDisplayFromMetadata(host.metadata.os);
  return (
    <div className={styles.HostSummaryRow}>
      <div className={styles.HostSummaryRow_segment}>
        <ClientVersion host={host} dataUpdatedAt={new Date(dataUpdatedAt)} />
      </div>
      <div className={styles.HostSummaryRow_segment}>
        &nbsp;/&nbsp;
        <LastSeenAt host={host} dataUpdatedAt={new Date(dataUpdatedAt)} />
      </div>
      {os ?
        <div className={styles.HostSummaryRow_segment}>
          <span>&nbsp;/&nbsp;</span>
          <span>{os.label}</span>
        </div>
      : null}
      {host.endpointOIDCUserID ?
        <div className={styles.HostSummaryRow_segment}>
          <span>&nbsp;/&nbsp;</span>
          <InlineIconLink
            className="flex"
            title={ownerEmail ? `Endpoint device owned by ${ownerEmail}` : 'Endpoint device'}
            to={`/hosts?filter.endpointOIDCUserID=${encodeURIComponent(host.endpointOIDCUserID)}`}
          >
            <UserIcon />
          </InlineIconLink>
        </div>
      : null}
    </div>
  );
}
